<template>
  <div>
    <div class="footer">
      <div class="footLeft">
        <div class="footImg">
          <img src="../assets/homeview/footLogo.png" alt="" />
        </div>
        <div class="foot">
          <div class="footT" v-for="(item, index) in foot" :key="index">
            <div class="footTitle">{{ item.nickname }}</div>
            <div @click="toPage(itemLsit)" v-for="(itemLsit,listIndex) in item.list?item.list.slice(0,6) : []" :key="listIndex" class="footText">{{ itemLsit.nickname }}</div>
          </div>
        </div>
      </div>
      <div class="footCenter"></div>
      <div class="footRight">
        <div class="footW">
          <img :src="message.qrcode1" alt="" />
          <img :src="message.qrcode2" alt="" />
        </div>
        <div class="footP">
          <div class="phone">
            <img src="../assets/homeview/phone.png" alt="" />
            <div class="figure">{{ message.phone }}</div>
          </div>
          <div class="message">
            <img src="../assets/homeview/duanxin.png" alt="" />
            <div class="figure">{{ message.email }}</div>
          </div>
          <div class="message">
            <div class="figure">公司全称：广州赛意信息科技股份有限公司</div>
          </div>
          <div class="message">
            <div class="figure">广州总部：广州市天河区珠江东路12号高德置地冬广场H座16楼</div>
          </div>
          <div class="message">
            <div class="figure">顺德研发总部：佛山市顺德区大良镇萃智路一号车创置业广场23楼</div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy">
      <div class="copyLeft">
        Copyright <sup>®</sup> 2019 SIE All Rights Reserved. sie
        粤ICP备16020564号
      </div>
      <!-- <div class="copyCenter">
        品牌网站：中联优谷
        <div class="copyRight">鲁ICP备16023919号-1</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      foot: [
        {
          nickname: "首页"
        },
      ],
      message: '',
    };
  },
  mounted() {
    this.getFoot();
    this.getFootList()
  },
  methods: {
    // 右侧二维码手机邮箱
    getFoot() {
      this.$http({
        url: "/index/footer", //请求的后台接口
        method: "get", //get请求方式
      }).then(({ data }) => {
        this.message = data.data
      });
    },
    // 导航栏列表
    getFootList() {
      this.$http({
        url: "/index/categorylist", //请求的后台接口
        method: "get", //get请求方式
      }).then(({ data }) => {
        console.log(data);
        this.foot = this.foot.concat(data.data);
      });
    },
    toPage(itemLsit) {
      this.$router.push({
        path: itemLsit.link,
        query: {id: itemLsit.id}
      })
      this.$emit('nameData',itemLsit)
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  background: #1D1D1D;
  padding: 0.8rem 1.8rem 0.75rem;
  box-sizing: border-box;

  .footLeft {
    .footImg {
      width: 1.4rem;
      height: 0.34rem;
    }

    .foot {
      display: flex;
      padding-top: 0.66rem;

      .footT {
        margin-right: 0.66rem;
        cursor: pointer;
        .footTitle {
          color: #FFFFFF;
          opacity: 0.8;
          font-weight: 400;
          font-size: 0.16rem;
          padding-bottom: 0.16rem;
          transition: all 0.3s;
          white-space:nowrap;
        }
        .footTitle:hover {
            color: #CF094B;
        }
        .footText {
          color: rgba(255, 255, 255, 0.4);
          font-weight: 400;
          font-size: 0.14rem;
          margin-top: 0.16rem;
          transition: all 0.3s;
          white-space:nowrap;
        }
        .footText:hover {
            color: #CF094B;
        }
      }
    }
  }

  .footCenter {
    width: 0.01rem;
    height: 1.31rem;
    background: rgba(255, 255, 255, 0.2);
    margin: 1.09rem 1.09rem 0 0.43rem;
  }

  .footRight {
    .footW {
      display: flex;

      img {
        width: 1.54rem;
        height: 1.57rem;
      }

      img:nth-child(1) {
        margin-right: 0.38rem;
      }
    }

    .footP {
      padding-top: 0.22rem;

      .phone {
        display: flex;
        margin-right: 0.12rem;
        align-items: center;

        img {
          width: 0.4rem;
          height: 0.4rem;
        }

        .figure {
          color: #FFFFFF;
          font-weight: 300;
          font-size: 0.16rem;
        }
      }

      .message {
        display: flex;
        // margin-right: 0.12rem;
        align-items: center;
        padding-top: 0.12rem;

        img {
          width: 0.4rem;
          height: 0.4rem;
        }

        .figure {
          color: #FFFFFF;
          font-weight: 300;
          font-size: 0.16rem;
          white-space: nowrap;
        }
      }
    }
  }
}

.copy {
  background: #1D1D1D;
  border-top: 0.01rem solid rgba(255, 255, 255, 0.2);
  padding: 0.16rem 1.8rem;
  display: flex;
  justify-content: space-between;

  .copyLeft, .copyCenter {
    color: #FFFFFF;
    opacity: 0.6;
    font-weight: 300;
    font-size: 0.14rem;
  }

  .copyCenter {
    display: flex;
  }

  .copyRight {
    padding-left: 0.16rem;
  }
}
</style>
